import { render, staticRenderFns } from "./TableHeaderGeneric.vue?vue&type=template&id=3320d8a6&scoped=true"
import script from "./TableHeaderGeneric.vue?vue&type=script&lang=ts"
export * from "./TableHeaderGeneric.vue?vue&type=script&lang=ts"
import style0 from "./TableHeaderGeneric.vue?vue&type=style&index=0&id=3320d8a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320d8a6",
  null
  
)

export default component.exports